import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { CircularProgress, Box } from "@mui/material";

/**
 * Auth + onboarding step guard for signup flows.
 * changeMode (account settings) bypasses sequencing requirements.
 */
const OnboardingRoute = ({
  children,
  requireAccountType = false,
  requireUsername = false,
}) => {
  const location = useLocation();
  const changeMode = Boolean(location.state?.changeMode);
  const { user, loadingUser, hasSelectedAccountType, hasUsername } = useUser();

  if (loadingUser) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!changeMode) {
    if (requireAccountType && !hasSelectedAccountType) {
      return <Navigate to="/account-type-selection" replace />;
    }
    if (requireUsername && !hasUsername) {
      return <Navigate to="/username-selection" replace />;
    }
  }

  return children;
};

export default OnboardingRoute;
